module.exports = __webpack_public_path__ + "img/project17_2.png.69842c90.webp";